import { IApplicationState } from '../../types/redux';

export function getFsk(state: IApplicationState) {
  return state.fsk;
}
